export default "__VITE_ASSET__DR205401__"